module.exports = __webpack_public_path__ + "teqbahn-assets/media/3_2_v1.fce15713.jpg";